import { useLoaderData } from "react-router-dom";
import { FlexPreview } from '../components';

export async function flexLoader({ params }) {
  const { avatarId } = params;
  return { avatarId };
}

export default function Flex() {
  const { avatarId } = useLoaderData();
  return (<FlexPreview avatarId={avatarId}/>); 
}
